export class STORAGEKEYS{
    public static USER_STATE = "USER_STATE";
    public static APPLICATION_STATE = "APPLICATION_STATE";
    public static ACCESS_TOKEN = "ACCESS_TOKEN";
    public static USER_SESSION = "USER_SESSION";
    public static SESSION_ID = "SESSION_ID";
    public static MOBILE_STATE = "MOBILE_STATE";
    public static CONSENT_STATE = "CONSENT_STATE";
    public static COOKIE_POPUP_SHOWED = "COOKIE_POPUP_SHOWED";
    public static COOKIE_CONSENT_CLICKED = "cookie_consent_clicked";
    public static COOKIE_CONSENT = "cookie_consent";
    public static CURRENT_WORKFLOW_ID = "CURRENT_WORKFLOW_ID";
    public static FORM_FILL_STARTING_TIME: "FORM_FILL_STARTING_TIME";
    public static JSC: "JSC";
    public static HDIM: "HDIM";

    //LENTOS
    public static OFFER_STATE = "OFFER_STATE";
    public static TEXT_CONTENTS_STATE = "TEXT_CONTENTS_STATE";
    public static LEN_CONFIG_STATE = "LEN_CONFIG_STATE";
    public static CONTRACT_SIGN_STATE = "CONTRACT_SIGN_STATE";
    public static LOAN_CALCULATOR_STATE = "LOAN_CALCULATOR_STATE";
    public static FORM_STATE = "FORM_STATE";
    public static SET_CURRENT_FORM_URL_PAGE_PATH = "SET_CURRENT_FORM_URL_PAGE_PATH";
    public static VIDEO_VERIFICATION_STATE = "VIDEO_VERIFICATION_STATE";

    public static FORM_AFFILIATE_DATA_COOKIE = "FORM_AFFILIATE_DATA_COOKIE";
    public static CURRENT_PAGE_STEP = "CURRENT_PAGE_STEP";
    public static SET_ALPHA_ID = "SET_ALPHA_ID";
    public static SET_MINIMUM_LOAN_AMOUNT = "SET_MINIMUM_LOAN_AMOUNT";
    public static IS_AFTER_BANK_VERIFICATION = "IS_AFTER_BANK_VERIFICATION";
    public static CLIENT_PESEL_RESERVED_IS_INTERVAL_RUNNING = "CLIENT_PESEL_RESERVED_IS_INTERVAL_RUNNING";
    public static CLIENT_PESEL_RESERVED_CURRENT_BLOCKING_TIME_IN_SECONDS = "CLIENT_PESEL_RESERVED_CURRENT_BLOCKING_TIME_IN_SECONDS";
    public static CURRENT_SELECTED_BANK_NAME = "CURRENT_SELECTED_BANK_NAME";
    public static ANALYTICS_SERVICE_SENDED_EVENTS_NAMES = 'ANALYTICS_SERVICE_SENDED_EVENTS_NAMES';
    public static LEAD_REDIRECT_VALID_TO = 'LEAD_REDIRECT_VALID_TO';
    public static LEAD_REDIRECT_DONE = 'LEAD_REDIRECT_DONE';
    public static WAS_USER_ON_OFFLINE_PAGE = 'WAS_USER_ON_OFFLINE_PAGE';
    public static CHANGE_LOADER_TEXT_START_TIME = 'CHANGE_LOADER_TEXT_START_TIME';

    // mObywatel
    public static CURRENT_MOBYWATEL_CODE = "CURRENT_MOBYWATEL_CODE";
    public static MOBYWATEL_IS_FIRST_RENDER = "MOBYWATEL_IS_FIRST_RENDER";
    public static MOBYWATEL_CODE_EXPIRED_TIME = "MOBYWATEL_CODE_EXPIRED_TIME";
    public static MOBYWATEL_IS_AFTER_FIRST_RENDER = "MOBYWATEL_IS_AFTER_FIRST_RENDER";
    public static IS_MOBYWATEL_MANUAL_VERIFICATION_SUCCEED = "IS_MOBYWATEL_MANUAL_VERIFICATION_SUCCEED";
}